export enum EBackgroundLayerType {
	LYST,
	SATELLIT,
	VFR,
}
